import React from "react";
import { Button, Container } from "react-bootstrap";
import { useScroll } from "../../../../context/scroll-context";

const briefcase =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/briefcase.svg";
const rocket =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/rocket.svg";
const customerService =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/services/customer-service.svg";

const HeroBanner = ({ title, content, backgroundImage, projectCount }) => {
  const { scrollToSection, pricing, contactform } = useScroll();
  const handleScrollAndClose = (refName) => {
    scrollToSection(refName);
  };
  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container fluid className="p-4 p-lg-5">
        <div className="content-block mb-3">
          <h2 className="text-white text-uppercase ft-wt-600 mb-4">
            {title}
          </h2>
          <p className="text-white mb-4">{content}</p>
          <div>
            <Button className="text-uppercase" variant="secondary">
              <h5
                className="mb-0 text-primary"
                onClick={() => handleScrollAndClose(contactform)}
              >
                Request a free Consultation
              </h5>
            </Button>
          </div>
        </div>
        <div className="d-flex align-items-center gap-3 gap-lg-5 flex-wrap mt-4 mt-lg-5">
          <div>
            <div className="d-flex gap-2 align-items-center">
              <div>
                <img src={briefcase} alt="experience" />
              </div>
              <Button
                variant="link"
                onClick={() => handleScrollAndClose(pricing)}
                className="p-0 text-decoration-underline text-white"
              >
                <h5 className="text-white mb-0">Plan and Pricing</h5>
              </Button>
            </div>
          </div>
          <div>
            <div className="d-flex gap-2 align-items-center">
              <div>
                <img src={customerService} alt="customerService" />
              </div>
              <h5 className="text-white mb-0">
                {projectCount} Projects Completed
              </h5>
            </div>
          </div>
          <div>
            <div className="d-flex gap-2 align-items-center">
              <div>
                <img src={rocket} alt="rocket" />
              </div>
              <h5 className="text-white mb-0">Flexible Engagement Models</h5>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default HeroBanner;
